<template>
  <div class="dialog_wrap" page-data="index:index" style="display: block;">
    <div class="dialog_layout">
      <div class="dialog_container">
        <img src="http://site.cc/static/txys-001/image/loading.gif" class="loading_img" style="display: none;">
        <div class="form_warp" style="display: block;">
          <div class="dialog_title">
            <span class="title"></span>
            <i class="dialog_close iconfont icon-chuyidong" @click="onClickCloseBtn"></i>
          </div>
          <div class="dialog_content">
            <form class="my_form form-horizontal" id="forms">
              <div class="form_content">
                <div class="form-tip-job">{{$t('widgets_basic_job_components_table1_2521')}}</div>
                <input type="hidden" name="id" id="id" value="3">
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2522')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="20" id="name"
                                                              name="name"
                                                              :placeholder="$t('view_test_2503')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('base_options_config_1784')}}</span><span
                    class="required_icon">*</span></h3>
                    <div class="item_type_phone content">
                      <div class="phone_number_area">
                        <div class="phone_number_wrap">
                          <input disabled autocomplete="off" maxlength="11" id="phone" name="phone"
                                 :placeholder="$t('view_login_index_48')"
                                 class="input_style jz_focus jz_theme_focus_border_color">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:34%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2523')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="50" id="email"
                                                              name="email"
                                                              :placeholder="$t('widgets_basic_job_components_table1_2524')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap form_item_wrap-resume" data-comb-dom="" style="width:100%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2525')}}</span></h3>
                    <div class="item_type_textarea content form-content-resume">
                      <div class="basic-job-resume resume-table-u711703 table-4" style="display: block;">
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-name"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="name" class="txt input-name">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-sex"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="sex" class="txt input-sex">
                            </div>
                          </div>
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-nation"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="nation" class="txt input-nation">
                            </div>
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-political"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="political" class="txt input-political">
                            </div>
                          </div>
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-native_place"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="native_place" class="txt input-native_place">
                            </div>
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-birthday"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="birthday" class="txt input-birthday">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-major"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="major" class="txt input-major">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-height"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="height" class="txt input-height">
                            </div>
                          </div>
                          <div class="my-col my-col-half">
                            <div class="el-col el-col-3">
                              <span class="label label-other_skill"></span>
                            </div>
                            <div class="el-col el-col-9">
                              <input type="text" data-field="other_skill" class="txt input-other_skill">
                            </div>
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-graduated_school"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="graduated_school" class="txt input-graduated_school">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-health"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="health" class="txt input-health">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-phone"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="phone" class="txt input-phone">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-mailing_address"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="mailing_address" class="txt input-mailing_address">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-email"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="email" class="txt input-email">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-education_back"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="education_back" class="txt input-education_back">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-winning"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="winning" class="txt input-winning">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-train"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="train" class="txt input-train">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-major_course"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="major_course" class="txt input-major_course">
                          </div>
                        </div>
                        <div class="el-row table-list">
                          <div class="el-col el-col-3">
                            <span class="label label-self_evaluate"></span>
                          </div>
                          <div class="el-col el-col-21">
                            <input type="text" data-field="self_evaluate" class="txt input-self_evaluate">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(value, key) in mobileLabelMap" :key="key" class="form_item_wrap form_item_wrap_mb"
                     style="width:100%">
                  <div class="form_item">
                    <h3 class="title"><span class="title_text">{{ value }}</span></h3>
                    <input
                      autocomplete="off" disabled maxlength="20"
                      ::placeholder="$t('widgets_basic_job_components_table1_2526', [value])"
                      class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div style="width:69%" class="form_item_wrap fixed_item formitem_validateCode" data-comb-dom="">
                  <div class="form_item">
                    <div class="item_type_validateCode content">
                      <input disabled autocomplete="off" :placeholder="$t('view_login_index_47')" maxlength="4" id="verify" name="verify"
                             class="validateCode_input input_style jz_focus jz_theme_focus_border_color">
                      <img alt=" " src="/static/image/verify.png" class="validateCode_img">
                    </div>
                  </div>
                </div>
                <div style="width:11%" class="form_item_wrap fixed_item formitem_submit" data-comb-dom="">
                  <div class="form_item" style="text-align: center">
                    <button class="form_submit content jz_theme_bg_color" type="button" @click="onClickSubmitBtn">{{$t('widgets_basic_job_components_table1_2527')}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_job_table4",
  data() {
    return {
      styleType: 4,
      widgetId: '',
      labelMap: {},
      mobileExcludeKeys: ['name', 'phone', 'email']
    }
  },
  computed: {
    mobileLabelMap() {
      return Object.keys(this.labelMap).filter(key => !this.mobileExcludeKeys.includes(key) && this.labelMap[key]).map(key => this.labelMap[key])
    }
  },
  methods: {
    onClickSubmitBtn() {
      this.$message({showClose: true, message: i18n.t('components_set_link_components_submit_form_index_2470')});
    },
    onClickCloseBtn() {
      this.close()
    },
    close() {
      $(this.$el).remove()
    }
  }
}
</script>

<style scoped lang="scss">
@import "./src/css/components/basic_job_table";
</style>



// WEBPACK FOOTER //
// src/widgets/basic_job/components/table4.vue